import React, { useEffect } from "react";
import Layout from "./components/Layout.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/HomeViews.js";
import Founder from './pages/Founder/Founder.js';
import BordVilla from './pages/BOREDVILLE/BOREDVILLE.jsx'; // Example additional page



import NotFound from './NotFound.js'; // 404 page

import './index.css';

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable image drag
    const imgs = document.querySelectorAll("img");
    imgs.forEach(img => {
      img.setAttribute("draggable", "false");
      img.style.pointerEvents = "none";
    });

    // Disable text/image selection
    document.body.style.userSelect = "none";
    document.body.style.webkitUserSelect = "none";
    document.body.style.mozUserSelect = "none";
    document.body.style.msUserSelect = "none";

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/TEAM" element={<Founder />} />
 <Route path="/BOREDVILLE" element={<BordVilla />} />

      
          <Route path="*" element={<NotFound />} /> {/* 404 Catch-All Route */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
